import { useContext } from 'react';

import { stepsContext } from '../contexts';

export const useStepsContext = () => useContext(stepsContext);
